module.exports = __webpack_public_path__ + "img/1521512062.bb69a4fc.jpg";